import {useRef, useEffect, useState, RefObject, Dispatch, SetStateAction} from 'react';

type HookAutocompleteDrDetailsReturnType = {
    autoCompleteValue: string;
    setAutoCompleteValue: Dispatch<SetStateAction<string>>;
    isPreviewVisible: boolean;
    setPreviewVisibility: Dispatch<SetStateAction<boolean>>;
    inputRef: RefObject<HTMLInputElement>;
    inputContainerRef: RefObject<HTMLDivElement>;
    handleClickOutside: (e: MouseEvent) => void;
};

/**
 * This hook return values and methods for control of input and preview in useAutocompleteDrDetails
 * @returns {HookAutocompleteDrDetailsReturnType} Rendered react component
 */
export const useAutocompleteDrDetails = (): HookAutocompleteDrDetailsReturnType => {
    const [autoCompleteValue, setAutoCompleteValue] = useState<string>('');
    const [isPreviewVisible, setPreviewVisibility] = useState<boolean>(true);
    const inputRef = useRef<HTMLInputElement>(null);
    const inputContainerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!isPreviewVisible) inputRef.current?.focus();
    }, [inputRef, isPreviewVisible]);

    /**
     * Listener for clicks outside of autocomplete component to enable preview visibility
     * @param {event} event - click event
     */
    const handleClickOutside = ({target}: MouseEvent) => {
        if (
            inputContainerRef.current &&
            !inputContainerRef.current.contains(target as Node | null)
        ) {
            setPreviewVisibility(true);
        }
    };

    return {
        autoCompleteValue,
        handleClickOutside,
        inputContainerRef,
        inputRef,
        isPreviewVisible,
        setAutoCompleteValue,
        setPreviewVisibility,
    };
};
